module.exports = __webpack_public_path__ + "static/media/HR.c16f126e.png";